import React, { Children } from 'react';
import { makeStyles } from '@material-ui/core';
import CardBase from '@material-ui/core/Card';

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: '80px',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 300ms linear',
    overflow: 'visible',
  },
}));

export function Card(props) {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
    <CardBase className={classes.card} {...rest}>
      {children}
    </CardBase>
  );
}
